import { appLoc } from "core/utils/helper";
import { regions } from "core/utils/region";
import {
  GET_APP_SETTING,
  GET_APP_SETTING_FAILED,
  GET_APP_SETTING_SUCCESS,
} from "./types";

export interface DataState {
  data: any;
  loadingAppSetting: boolean;
  type: any;
}

const initialState: DataState = {
  data: {},
  loadingAppSetting: false,
  type: "",
};

const AppSettingsReducer = (
  state: DataState = initialState,
  action: any
): DataState => {
  switch (action.type) {
    case GET_APP_SETTING:
      return {
        ...state,
        loadingAppSetting: true,
        data: {...state.data, region: regions[appLoc()]},
        type: action.type,
      };
    case GET_APP_SETTING_SUCCESS:
      localStorage.setItem("languages", JSON.stringify(action.payload.data?.languages|| []));
      return {
        ...state,
            data: {...action.payload.data, region: regions[appLoc()]},
        loadingAppSetting: false,
        type: action.type,
      };
		case GET_APP_SETTING_FAILED:
			return {
				...state,
                data: {...state.data, region: regions[appLoc()]},
				loadingAppSetting: false,
				type: action.type,
			};
    default:
      return state;
  }
};

export default AppSettingsReducer;
